export default __webpack_public_path__ + "static/media/lunchHealthgenom.a856033a.svg";